import { Injectable } from '@angular/core';
import * as Papa from 'papaparse';

@Injectable({ providedIn: 'root' })
export class CsvParserService {
  parseCSVFromString(text: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
      // Validate input
      if (!text || text.trim().length === 0) {
        reject(new Error('CSV content is empty'));
        return;
      }

      Papa.parse(text, {
        header: true,
        skipEmptyLines: true,
        transformHeader: (header: string) => {
          // Clean up header names (remove extra spaces, normalize case)
          return header.trim().toLowerCase().replace(/\s+/g, '_');
        },
        complete: (results) => {
          if (results.errors && results.errors.length > 0) {
            // Check for critical errors
            const criticalErrors = results.errors.filter(error => 
              error.type === 'Delimiter' || error.type === 'Quotes'
            );
            
            if (criticalErrors.length > 0) {
              reject(new Error(`CSV parsing failed: ${criticalErrors[0].message}`));
              return;
            }
          }

          const data = results.data as any[];
          
          // Validate that we have data
          if (!data || data.length === 0) {
            reject(new Error('No data found in CSV file'));
            return;
          }

          // Filter out completely empty rows
          const validData = data.filter(row => 
            Object.values(row).some(value => 
              value !== null && value !== undefined && String(value).trim() !== ''
            )
          );

          if (validData.length === 0) {
            reject(new Error('No valid data rows found in CSV file'));
            return;
          }

          resolve(validData);
        },
        error: (error: any) => {
          reject(new Error(`CSV parsing error: ${error.message}`));
        }
      });
    });
  }

  // Helper method to validate if the CSV structure looks like GSC data
  validateGSCStructure(data: any[], expectedType: 'query' | 'page'): boolean {
    if (!data || data.length === 0) return false;

    const firstRow = data[0];
    const headers = Object.keys(firstRow);

    // Common GSC headers (normalized to lowercase with underscores)
    const queryHeaders = ['query', 'clicks', 'impressions', 'ctr', 'position'];
    const pageHeaders = ['page', 'clicks', 'impressions', 'ctr', 'position'];

    const requiredHeaders = expectedType === 'query' ? queryHeaders : pageHeaders;
    
    // Check if at least 3 of the required headers are present
    const matchingHeaders = requiredHeaders.filter(header => 
      headers.includes(header)
    );

    return matchingHeaders.length >= 3;
  }
}